import {
  Box,
  Button,
  Divider,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Card,
  CardBody,
} from "@chakra-ui/react";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import RmCarousel from "../Components/Home/Carousel";
import Category from "../Components/Home/Category";
import Listicle from "../Components/Home/Listicle";
import Navbar from "../Components/Navbar";

const Home = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const finalRef = React.useRef(null);
  let city = localStorage.getItem("city");
  let navigate = useNavigate();
  function handleSelectCity(city){
    localStorage.setItem("city", city)
  }
  useEffect(()=>{
    if(city){
      navigate(`/${city}`)
    }
  },[])
  useEffect(() => {
    onOpen();
  }, []);
  return (
    <div>
      <RmCarousel />
      <Category />
      <Listicle />
      {/* <Button mt={4} onClick={onOpen}>
        Open Modal
      </Button> */}
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        // onClose={onClose}
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modal Title</ModalHeader>
          {/* <ModalCloseButton /> */}
          <ModalBody>
            <Box>😊 We curate products for you as per your city</Box>
            <Box>Please choose a city</Box>
            <Divider />
            <Input />
            <Flex justifyContent={"space-between"}>
              <Link to={"/delhi"}>
                <Card>
                  <CardBody onClick={()=>handleSelectCity("delhi")}>Delhi</CardBody>
                </Card>
              </Link>
              <Card>
                <CardBody>Mumbai</CardBody>
              </Card>
              <Card>
                <CardBody>Bangalore</CardBody>
              </Card>
            </Flex>
          </ModalBody>

          {/* <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button variant="ghost">Secondary Action</Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Home;
